export enum RegisterActions {
  RESET_REGISTRATION = 'RESET_REGISTRATION',
  SET_ACTIVE_STEP = 'SET_ACTIVE_STEP',
  SAVE_REGISTRATION_DATA = 'SAVE_REGISTRATION_DATA',
  SET_IS_REGISTRATION_COMPLETED = 'SET_IS_REGISTRATION_COMPLETED',
  SET_FINAL_PRICE = 'SET_FINAL_PRICE',
  SET_FORM_ERRORS = 'SET_FORM_ERRORS',
  SET_SELECTED_ACTIVITIES = 'SET_SELECTED_ACTIVITIES',
  SET_IS_MAIN_USER_STUDENT = 'SET_IS_MAIN_USER_STUDENT',
  SET_IS_PARTNER_STUDENT = 'SET_IS_PARTNER_STUDENT',
  SET_IS_MAIN_USER_SIBLING = 'SET_IS_MAIN_USER_SIBLING',
  SET_IS_PARTNER_SIBLING = 'SET_IS_PARTNER_SIBLING',
  SET_IS_MAIN_USER_SENIOR = 'SET_IS_MAIN_USER_SENIOR',
  SET_IS_PARTNER_SENIOR = 'SET_IS_PARTNER_SENIOR',
  SET_ENROLLMENT_ID = 'SET_ENROLLMENT_ID',
  SET_PAYMENT_METHOD = 'SET_PAYMENT_METHOD',
  SET_IS_PAID = 'SET_IS_PAID',
  SET_PAYMENT_STATUS = 'SET_PAYMENT_STATUS',
  SET_IS_REGISTRATION_SUBMITTED = 'SET_IS_REGISTRATION_SUBMITTED',
  SET_MAIN_USER_ACTIVE_PERIODS = 'SET_MAIN_USER_ACTIVE_PERIODS',
  SET_PARTNER_USER_ACTIVE_PERIODS = 'SET_PARTNER_USER_ACTIVE_PERIODS',
  SET_MAIN_USER_PREVIOUS_DISCOUNTS = 'SET_MAIN_USER_PREVIOUS_DISCOUNTS',
  SET_PARTNER_USER_PREVIOUS_DISCOUNTS = 'SET_PARTNER_USER_PREVIOUS_DISCOUNTS',
  SET_OBFUSCATED_ENROLLMENT = 'SET_OBFUSCATED_ENROLLMENT',
  SET_MAIN_USER_SSN = 'SET_MAIN_USER_SSN',
  SET_PARTNER_USER_SSN = 'SET_PARTNER_USER_SSN',
  SET_ENROLLMENT_COMMENT = 'SET_ENROLLMENT_COMMENT',
  SET_ENROLLMENT_DISCOUNT_CODE = 'SET_ENROLLMENT_DISCOUNT_CODE',
  SET_ENROLLMENT_REGISTERED_PARTNERS = 'SET_ENROLLMENT_REGISTERED_PARTNERS',
  SET_PAYFOR = 'SET_PAYFOR',
  SET_DISCOUNT_TYPE = 'SET_DISCOUNT_TYPE',
  SET_DISCOUNT_REGION = 'SET_DISCOUNT_REGION',
  SET_INDIVIDUAL_FLOW = 'SET_INDIVIDUAL_FLOW',
  SET_ROLE = 'SET_ROLE',
  SET_PARTNER_ROLE = 'SET_PARTNER_ROLE',
  SET_EARLY_BIRD_BOOKING = 'SET_EARLY_BIRD_BOOKING',
  SET_SINGLE_EVENT_QUANTITY = 'SET_SINGLE_EVENT_QUANTITY',
  SET_CHILDREN_INPUT = 'SET_CHILDREN_INPUT'
}
